import { Header, Page } from 'redesign';
import { PaymentUsersTableDataProvider } from './payment-users-table';
import { PaymentUsersToolbox } from './payment-users-toolbox';
import { usePaymentUsersPage } from './hooks/use-payment-users-page';
import { PaymentUsersFiltersDataProvider } from './filters/payment-users-filters-data-provider';
import { useToggle } from '../../../../../shared/hooks';

export const PaymentUsers = () => {
  const { on: filtersOpen, toggle: toggleFilters } = useToggle();
  const { filters: appliedFilters, setFilters, selectedFilterCount } = usePaymentUsersPage();

  return (
    <Page
      header={<Header titleText="Betalingsgebruikers" />}
      toolbox={
        <PaymentUsersToolbox
          selectedFilterCount={selectedFilterCount}
          appliedFilters={appliedFilters}
          toggleFilters={toggleFilters}
        />
      }
    >
      <PaymentUsersFiltersDataProvider
        toggleFilters={toggleFilters}
        appliedFilters={appliedFilters}
        handleFiltersChange={setFilters}
        isOpen={filtersOpen}
      />
      <PaymentUsersTableDataProvider />
    </Page>
  );
};
